import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/views/main/index.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index.vue'),
      },
      {
        path: '/business',
        name: 'business',
        component: () => import('@/views/business/index.vue'),
      },
      {
        path: '/gametool',
        name: 'gametool',
        component: () => import('@/views/gametool/index.vue'),
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
      },
      {
        path: '/news/newsDetail/:newsId',
        name: 'newsDetail',
        component: () => import('@/views/newsDetail/index.vue'),
        props: true,
      },
      {
        path: '/join',
        name: 'join',
        component: () => import('@/views/join/index.vue'),
      },
    ],
  },
  {
    path: '/index.html',
    redirect: '/home',
  },
  {
    path: '/cp2',
    redirect: '/home',
  },
  // 内部健康检查需要用到的路由
  {
    path: '/healthCheck',
    name: 'healthCheck',
    component: () => import('@/views/healthCheck/index.vue'),
  },
]

export default routes
